import { useEffect, useState } from 'react';

import { currentPassword as currentPasswordField } from '#src/components/Form/fields.ts';
import type { Data } from '#src/components/Form/index.tsx';
import Form from '#src/components/Form/index.tsx';
import useInfo from '#src/hooks/useInfo.ts';
import useWalletIsLocked from '#src/hooks/useWalletIsLocked.ts';

import ForgotPassword from './ForgotPassword.tsx';

const field = currentPasswordField;
type Field = (typeof field)[0];

interface Props {
  presetErrors?: Record<string, string | null>;
  onSubmit: (result: Data<Field>) => Promise<Partial<Data<Field>> | void>;
}

const WalletIsLocked = ({ onSubmit, presetErrors }: Props) => {
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const { dict } = useInfo();
  const walletIsLocked = useWalletIsLocked();

  useEffect(() => {
    walletIsLocked(true);
    return () => walletIsLocked(false);
  }, [walletIsLocked]);

  return (
    <div className="V2WalletForm wallet-drawer">
      {!showForgotPassword && (
        <div>
          <Form
            presetErrors={presetErrors}
            inputs={[field]}
            onSubmit={onSubmit}
            submitLabel={dict.unlock}
          />
          <button
            onClick={() => setShowForgotPassword(true)}
            className="passwordForgotten"
            type="button"
          >
            {dict.forgotPassword}
          </button>
        </div>
      )}
      {!!showForgotPassword && (
        <ForgotPassword
          onSuccess={() => setShowForgotPassword(false)}
          onBack={() => setShowForgotPassword(false)}
          mode="drawer"
        />
      )}
    </div>
  );
};

export default WalletIsLocked;
